import { ListCell } from '@axa-asia/emma-stylesheet/lib/components/ListTable';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import LoadingView from '../../../../components/LoadingView';
import { ENTITY_CODE } from '../../../../constants/constants';
import { t } from '../../../../locales';
import browserHistory from '../../../../stores/browserHistory';
import {
  isApp,
  resolveLocalizedText,
  resolveSingularPlural,
} from '../../../../utils';
import { fetchPolicyCards } from '../../actions/changeContactAction';
import { fetchCustomerPermissions } from '../../actions/customerProfileAction';
import BackNavButton from '../../components/BackNavButton';
import ChangeContactBanner from '../../components/ChangeContact/ChangeContactBanner';
import ChangeContactCard from '../../components/ChangeContact/ChangeContactCard';
import SliderCard from '../../components/ChangeContact/SliderCard';
import {
  getChangeContactLabelsConfig,
  getChangeContactLoading,
  getChangeContactPolicyCards,
} from '../../selectors/changeContactSelector';
import { getCustomerProfileLoading, getCustomerUserData } from '../../selectors/customerProfileSelectors';
import { editPolicyInfoLabels } from '../../types/editPolicyInfo';
import './style.scss';

export interface ChangeContactContainerProps {
  userData: any;
  policyCards: Array<any>;
  editPolicyInfoLabels: editPolicyInfoLabels;
  isLoading: boolean;
  isCustomerPermissionsLoading: boolean;
  onFetchPolicyCards: (params?: any) => void;
  onFetchCustomerPermissions: () => void;
}

export interface ChangeContactContainerState {}

export class ChangeContactContainer extends Component<
  ChangeContactContainerProps,
  ChangeContactContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (isApp()) {
      const title = t(`CUSTOMER_PROFILE_CHANGE_CONTACT_TITLE`);
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
    }

    // userData is no longer loaded at start (HKEMMA-108151)
    // For cases when user is from mobile app or not enter thru my profile (HKEMMA-110559)
    if (Object.keys(this.props.userData).length === 0) {
      this.props.onFetchCustomerPermissions();
    }

    this.props.onFetchPolicyCards();
    
    // registerHistoryIndex(CHANGE_CONTACT_ID);
  }

  onGoBack = () => {
    browserHistory.goBack();
    // goto('emma-customer-profile');
  };

  render() {
    const {
      editPolicyInfoLabels,
      policyCards,
      isLoading,
      isCustomerPermissionsLoading,
      userData,
    } = this.props;
    const isPNCOnly: boolean = policyCards.every(
      (policy) => policy.entityCode === ENTITY_CODE.GHK,
    );
    const { lastNm, dob, idDocNo } = userData;
    const {
      title,
      information,
      informationName,
      informationDateOfBirth,
      informationNationalID,
      policyCount,
    } = editPolicyInfoLabels;
    return isLoading || isCustomerPermissionsLoading ? (
      <LoadingView />
    ) : (
      <div className="change-contant-wrap">
        <div className="customer-profile-backbutton">
          <BackNavButton onClick={this.onGoBack} blue title={t('BACK')} />
        </div>
        <div className="change-contant emma-stylesheet-grid-system">
          {!isApp() && (
            <div className="change-contant-title">
              {title ? resolveLocalizedText(title) : ''}
            </div>
          )}
          <div className="change-contant-sub-title">
            {information ? resolveLocalizedText(information) : ''}
          </div>
          <div className="change-contant-information">
            {lastNm && (
              <ListCell
                cellClass="change-contant-information-list-cell"
                title={
                  informationName ? resolveLocalizedText(informationName) : ''
                }
                value={lastNm}
              />
            )}
            {dob && !isPNCOnly && (
              <ListCell
                cellClass="change-contant-information-list-cell"
                title={
                  informationDateOfBirth
                    ? resolveLocalizedText(informationDateOfBirth)
                    : ''
                }
                value={dob && moment(dob).format('YYYY/MM/DD')}
              />
            )}
            {idDocNo && (
              <ListCell
                cellClass="change-contant-information-list-cell"
                title={
                  informationNationalID
                    ? resolveLocalizedText(informationNationalID)
                    : ''
                }
                value={idDocNo}
              />
            )}
          </div>
          <div className="change-contant-sub-title">
            {policyCount
              ? resolveSingularPlural(
                  policyCards.length,
                  resolveLocalizedText(policyCount),
                ).replace('${policyCount}', `${policyCards.length}`)
              : ''}
          </div>
          <div className="change-contant-card-wrap">
            <SliderCard>
              {policyCards.map((item, index) => (
                <ChangeContactCard {...item} key={index} />
              ))}
            </SliderCard>
          </div>
          <ChangeContactBanner />
        </div>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const userData = getCustomerUserData(state);
    return {
      userData,
      policyCards: getChangeContactPolicyCards(state) || [],
      editPolicyInfoLabels: getChangeContactLabelsConfig(state) || {},
      isLoading: getChangeContactLoading(state),
      isCustomerPermissionsLoading: getCustomerProfileLoading(state),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onFetchPolicyCards: (params: any) => dispatch(fetchPolicyCards(params)),
      onFetchCustomerPermissions: () => dispatch(fetchCustomerPermissions()),
    };
  }
}

export default connect(
  ChangeContactContainer.mapStateToProps,
  ChangeContactContainer.mapDispatchToProps,
)(ChangeContactContainer);
